export enum SharedItemMessagePatientResponseType {
    Message,
    Attachment
}
